module.exports = __webpack_public_path__ + "static/media/edit-icon-blue.b1c3152c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit-icon-blue.svg
// module id = 1974
// module chunks = 0